import AuthService from '@/services/auth-service';
import { errorResponseSchema } from '@/schemas/errorResponseSchema';
import { ApiError } from '@/constants/errorTypes';
import * as Sentry from '@sentry/react';
import environment from '@/environment';

export async function networkRequest(request: Request): Promise<unknown> {
  const response = await fetch(request);
  return await handleResponse(request, response);
}

export function createHeaders(): Headers {
  const accessToken = AuthService.getAccessToken();
  const headers = new Headers();

  headers.append('Content-Type', 'application/json');

  if (accessToken) {
    headers.append('ACCESS_TOKEN', accessToken);
  }

  return headers;
}

async function handleResponse(request: Request, response: Response): Promise<unknown> {
  if (!response.ok) {
    const responseData: unknown = await response.json();
    const errorParseResult = errorResponseSchema.safeParse(responseData);
    const errorData = errorParseResult.success ? errorParseResult.data : undefined;

    const error = new ApiError(request, response, errorData);

    // --- capture here, before throwing ---
    if (environment.sentryEnabled) {
      Sentry.withScope((scope) => {
        const tags = error.toSentryTags();
        Object.entries(tags).forEach(([k, v]) => v && scope.setTag(k, v));
        scope.setExtras(error.toSentryExtras());
        Sentry.captureException(error);
      });
    }

    throw error;
  }

  return response.json();
}
